import { Wrench, Snowflake, ThermometerSnowflake, Flame, Zap, Settings, Drill, Building2 } from "lucide-react";
import { Reveal, Eyebrow, SectionTitle } from "../Reveal";

const JOBS = [
  { icon: Wrench, label: "Plombiers" },
  { icon: Snowflake, label: "Climaticiens" },
  { icon: ThermometerSnowflake, label: "Frigoristes" },
  { icon: Flame, label: "Chauffagistes" },
  { icon: Zap, label: "Électriciens" },
  { icon: Settings, label: "Maintenance" },
  { icon: Drill, label: "Installateurs" },
  { icon: Building2, label: "Autres métiers du bâtiment" },
];

export default function Professions() {
  return (
    <section id="metiers" className="py-16 sm:py-24 bg-[#141619]/40 border-y border-[#2E333D]/50" data-testid="professions-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <Eyebrow>Professionnels</Eyebrow>
          <SectionTitle>Pensée pour les professionnels.</SectionTitle>
          <p className="mt-6 text-gray-400 max-w-2xl leading-relaxed">
            Une solution pensée pour tous les professionnels qui utilisent régulièrement
            des petites pièces et des consommables.
          </p>
        </Reveal>
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-4">
          {JOBS.map((j, i) => (
            <Reveal key={j.label} delay={i * 0.05}>
              <div className="h-full border border-[#2E333D] bg-[#0C0D0E] rounded-xl p-6 text-center hover:border-[#FFC700]/50 hover:-translate-y-1 transition-all" data-testid={`profession-card-${i}`}>
                <j.icon size={26} className="text-[#FFC700] mx-auto mb-4" />
                <p className="font-display font-bold uppercase tracking-wide text-[#F9FAFB]">{j.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
